export default __webpack_public_path__ + "static/media/FrenchCanon.7e2c69e4.woff";